import { UserPreferenceKeys } from "./userPreferencesSlice";

import { LOCALSTORAGE_PREFIX } from "../app/constants";
import type { SupportedLanguage } from "../config/types";
import { safeLocalStorage } from "../utils/utils";

export const getInitialLanguage = (): SupportedLanguage | null => {
  // 1st stored on localstorage
  const storedLang = getInitialValue(UserPreferenceKeys.LANGUAGE, undefined);
  if (storedLang) {
    try {
      return JSON.parse(storedLang) as SupportedLanguage;
      // resetUser url lng query param?
    } catch {
      return null;
    }
  }

  // 2nd query param
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const queryLang = params.get("lng") as SupportedLanguage | null;
    if (queryLang) return queryLang;
  }

  return null;
};

export const getStoredValue = <T>(key: UserPreferenceKeys): T | null => {
  const item = safeLocalStorage.getItem(LOCALSTORAGE_PREFIX + key);
  if (!item) return null;

  try {
    return JSON.parse(item) as T;
  } catch {
    return null;
  }
};

export const getInitialValue = <T>(
  key: UserPreferenceKeys,
  defaultValue: T,
): T => {
  const storedValue = getStoredValue<T>(key);
  return storedValue ?? defaultValue;
};
